var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477.255 136h-29.373c.172-2.194.119 6.049.119-101.255C448 15.586 432.414 0 413.255 0H98.745C79.586 0 64 15.586 64 34.745c0 107.073-.055 99.045.119 101.255H34.745C15.586 136 0 151.586 0 170.745v186.51C0 376.414 15.586 392 34.745 392H120v85.255C120 496.414 135.586 512 154.745 512h202.51C376.414 512 392 496.414 392 477.255V392h85.255C496.414 392 512 376.414 512 357.255v-186.51C512 151.586 496.414 136 477.255 136zM96 133.255v-98.51A2.748 2.748 0 0 1 98.745 32h314.51A2.748 2.748 0 0 1 416 34.745v98.51a2.748 2.748 0 0 1-2.745 2.745H98.745A2.748 2.748 0 0 1 96 133.255zm264 344a2.748 2.748 0 0 1-2.745 2.745h-202.51a2.748 2.748 0 0 1-2.745-2.745v-162.51a2.748 2.748 0 0 1 2.745-2.745h202.51a2.748 2.748 0 0 1 2.745 2.745zm120-120a2.748 2.748 0 0 1-2.745 2.745H392v-45.255C392 295.586 376.414 280 357.255 280h-202.51C135.586 280 120 295.586 120 314.745V360H34.745A2.748 2.748 0 0 1 32 357.255v-186.51A2.748 2.748 0 0 1 34.745 168h442.51a2.748 2.748 0 0 1 2.745 2.745z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 224h-24c-8.836 0-16-7.164-16-16s7.164-16 16-16h24c8.836 0 16 7.164 16 16s-7.164 16-16 16zM304 376h-96c-8.836 0-16-7.164-16-16s7.164-16 16-16h96c8.836 0 16 7.164 16 16s-7.164 16-16 16zM304 448h-96c-8.836 0-16-7.164-16-16s7.164-16 16-16h96c8.836 0 16 7.164 16 16s-7.164 16-16 16z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.41206189e4850de56eda1f990e0be260.svg";
export { ForwardRef as ReactComponent };